<div class="ad-container overflow-hidden border-radius-5px border-1px h-100" [style.background-image]="'url(' + adconfig.url + ')'">
  <a class="align-items-center d-flex position-relative padding-for-16-9 h-100" [href]="adconfig.clickthroughLink"
    target="_blank" rel="noopener noreferrer">
    <img class="position-absolute ad-img" [src]="adconfig.url" [alt]="'GENERIC.COMMON_PAGES.AD_BANNER_IMAGE_ALTERNATE_TEXT' | translate">
  </a>
</div>
